import { combineReducers } from '@reduxjs/toolkit';
import { entryTypesReducer } from "./entryTypes";
import { conditionTypesReducer } from "./conditionTypes";
import { operationTypesReducer } from "./operationTypes";
export const reducers = {
  entryTypes: entryTypesReducer,
  conditionTypes: conditionTypesReducer,
  operationTypes: operationTypesReducer
};
export const typesReducer = combineReducers(reducers);